import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';
import { MsalProvider } from '@azure/msal-react';
import { SnackbarGlobal } from '@pu/mpp-ui/components/snackbar';
import { diadiaTheme, ThemeProvider } from '@pu/mpp-ui/themes';
import { PersistGate } from 'redux-persist/integration/react';
import msalPublicClientApplication from 'core/constants/msal.constants';
import store, { persistor } from 'core/store';
import { Loading } from 'shared/components/loading';
import { VersionBadge } from 'shared/components/version-badge';
import { useGlobalNotifications } from 'shared/hooks/use-global-notifications.hook';
import 'shared/utils/yup.utils';
import { appRoutes } from './app.routes';

const App = () => {
  useGlobalNotifications();

  return (
    <>
      <VersionBadge />
      <MsalProvider instance={msalPublicClientApplication}>
        <ThemeProvider theme={diadiaTheme}>
          <SnackbarGlobal position="right-top" />
          <Provider store={store}>
            <PersistGate loading={<Loading />} persistor={persistor}>
              <RouterProvider router={appRoutes} />
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </MsalProvider>
    </>
  );
};

export default App;
